/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ percent: NonNullable<unknown> }} Video_Export_Alpha_ProgressInputs */

const en_video_export_alpha_progress = /** @type {(inputs: Video_Export_Alpha_ProgressInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Exporting alpha video: ${i?.percent}%`)
};

const fr_video_export_alpha_progress = /** @type {(inputs: Video_Export_Alpha_ProgressInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Exportation video alpha : ${i?.percent}%`)
};

const de_video_export_alpha_progress = /** @type {(inputs: Video_Export_Alpha_ProgressInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Alpha-Video exportieren: ${i?.percent}%`)
};

const it_video_export_alpha_progress = /** @type {(inputs: Video_Export_Alpha_ProgressInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Esportazione video alfa: ${i?.percent}%`)
};

const ru_video_export_alpha_progress = /** @type {(inputs: Video_Export_Alpha_ProgressInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Экспорт альфа-канала видео: ${i?.percent}%`)
};

const es_video_export_alpha_progress = /** @type {(inputs: Video_Export_Alpha_ProgressInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Exportando vídeo alfa: ${i?.percent}%`)
};

const zh_cn2_video_export_alpha_progress = /** @type {(inputs: Video_Export_Alpha_ProgressInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`导出 Alpha 视频：${i?.percent}%`)
};

const ja_video_export_alpha_progress = /** @type {(inputs: Video_Export_Alpha_ProgressInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`アルファビデオをエクスポートしています: ${i?.percent}%`)
};

const hi_video_export_alpha_progress = /** @type {(inputs: Video_Export_Alpha_ProgressInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`अल्फा वीडियो निर्यात किया जा रहा है: ${i?.percent}%`)
};

const pt_pt2_video_export_alpha_progress = /** @type {(inputs: Video_Export_Alpha_ProgressInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Exportando vídeo alfa: ${i?.percent}%`)
};

/**
* | output |
* | --- |
* | "Exporting alpha video: {percent}%" |
*
* @param {Video_Export_Alpha_ProgressInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const video_export_alpha_progress = /** @type {((inputs: Video_Export_Alpha_ProgressInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Video_Export_Alpha_ProgressInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_video_export_alpha_progress(inputs)
	if (locale === "de") return de_video_export_alpha_progress(inputs)
	if (locale === "it") return it_video_export_alpha_progress(inputs)
	if (locale === "ru") return ru_video_export_alpha_progress(inputs)
	if (locale === "es") return es_video_export_alpha_progress(inputs)
	if (locale === "zh-CN") return zh_cn2_video_export_alpha_progress(inputs)
	if (locale === "ja") return ja_video_export_alpha_progress(inputs)
	if (locale === "hi") return hi_video_export_alpha_progress(inputs)
	if (locale === "pt-PT") return pt_pt2_video_export_alpha_progress(inputs)
	return en_video_export_alpha_progress(inputs)
});